import { SET_AUTH_DATA, LOGOUT_USER, VERIFIED_USER } from "store/types/AuthData"

export const setAuthData = (authData) => {
    return {
        type: SET_AUTH_DATA,
        authData
    }
}

export const logOut = () => {
    return {
        type: LOGOUT_USER,
    }
}

export const changeVerificationStatus = (status) => {
    return {
        type: VERIFIED_USER,
        payload: status
    }
}